import React, { useState, useEffect } from "react";
import { Col, Row, Image } from "react-bootstrap";
import { ChartsComponent } from "../../../reusableComponent";

// charts constants
import { PROJECT_MONITORED_CHART_HELPER } from "./column.first";
import { PROJECT_MONITORED_DASHBOARD_CHART_HELPER } from "./column.first.dashboard";
import { ISSUE_MONITORED_CHART_HELPER } from "./spline.second";
import { ISSUE_MONITORED_CHART_DASHBOARD_HELPER } from "./spline.second.dashboard";
import { ISSUES_WITH_PMG_HELPER } from "./pie.third";
import {
  STATUS_BREAK_UP_HELPER,
  STATUS_BREAK_UP_COST_HELPER
} from "./stacked.fourth";

// actions
import {
  getPMGMonitoredIssuesAction,
  getPMGMonitoredProjectAction,
  getIssueByCategoryAction,
  getProjectsByCompletionStageAction
} from "../../../../actions/reports.action";

// helper
import ChartsDetails from "./ChartsDetails";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ISSUE_MONITORED_CHART_RESPONSIVE_HELPER } from "./spline.second.responsive";
import { PROJECT_MONITORED_RESPONSIVE_CHART_HELPER } from "./column.first.responsive";

const FirstPage = React.memo(function FirstPage({
  displayOnDashboard = false,
  dashboardClass,
  isDesktopView,
  checkedValue
}) {
  const [pmgMonitoredProject, setPmgMonitoredProject] = useState({
    isLoading: false,
    data: []
  });
  const [pmgMonitoredIssues, setPmgMonitoredProjectIssues] = useState({
    isLoading: false,
    data: []
  });
  const [issuesWithPMG, setIssuesWithPMG] = useState({
    isLoading: false,
    data: []
  });
  const [projectStage, setProjectStage] = useState({
    isLoading: false,
    data: []
  });

  const [updateValue, setUpdateValue] = useState(0);

  useEffect(() => {
    getProjectMonitoredApisData();
    getIssuesMonitoredApisData();
    getIssuesWithPMGApisData();
    projectsByCompletionStageData();
  }, [checkedValue]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [updateValue]);

  const onScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (isDesktopView) {
      if (currentOffset > 450 && currentOffset < 650) {
        setUpdateValue(updateValue + 1);
      }
    }
    if (
      (currentOffset > 2 && currentOffset < 100) ||
      (currentOffset > 420 && currentOffset < 520)
    ) {
      setUpdateValue(updateValue + 1);
    }
  };

  const getProjectMonitoredApisData = async () => {
    // loading started
    setPmgMonitoredProject({ isLoading: true, data: [] });
    // get data
    const projectReportResp = await getPMGMonitoredProjectAction(
      undefined,
      checkedValue
    );
    // loading completed
    setPmgMonitoredProject({
      isLoading: false,
      data: projectReportResp.data || []
    });
  };

  const getIssuesMonitoredApisData = async () => {
    // loading started
    setPmgMonitoredProjectIssues({ isLoading: true, data: [] });
    // get data
    const issueReportResp = await getPMGMonitoredIssuesAction(
      undefined,
      checkedValue
    );
    // loading completed
    setPmgMonitoredProjectIssues({
      isLoading: false,
      data: issueReportResp.data || []
    });
  };

  const getIssuesWithPMGApisData = async () => {
    // loading started
    setIssuesWithPMG({ isLoading: true, data: [] });
    // get data
    const issueReportResp = await getIssueByCategoryAction();
    // loading completed
    setIssuesWithPMG({
      isLoading: false,
      data: issueReportResp.data || []
    });
  };

  const projectsByCompletionStageData = async () => {
    // loading started
    setProjectStage({ isLoading: true, data: [] });
    // get data
    // Dashboard Projects Status Graph
    const projectStageResp = await getProjectsByCompletionStageAction(
      undefined,
      checkedValue
    );
    // loading completed
    setProjectStage({
      isLoading: false,
      data: projectStageResp.data || []
    });
  };

  let settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
    //autoplay:false,
    // autoplaySpeed:3000
  };

  return (
    <>
      {/* PDF First Section Start */}
      {!isDesktopView && displayOnDashboard ? (
        <Slider {...settings}>
          <ChartsComponent
            isLoading={pmgMonitoredProject.isLoading}
            chartConfig={PROJECT_MONITORED_RESPONSIVE_CHART_HELPER(
              pmgMonitoredProject.data
            )}
            displayOnDashboard={displayOnDashboard}
            displayTitle="PMG Monitored Projects"
            extraTopSpace={true}
            updateValue={updateValue}
          />
          <ChartsComponent
            isLoading={pmgMonitoredIssues.isLoading}
            chartConfig={ISSUE_MONITORED_CHART_RESPONSIVE_HELPER(
              pmgMonitoredIssues.data
            )}
            displayOnDashboard={displayOnDashboard}
            displayTitle="PMG Monitored Issues"
            extraTopSpace={true}
            updateValue={updateValue}
          />
        </Slider>
      ) : (
        <div className={`charts-sections ${dashboardClass}`}>
          <div className="chart">
            {/* Section */}
            <div className="even">
              <ChartsComponent
                isLoading={pmgMonitoredProject.isLoading}
                chartConfig={
                  displayOnDashboard
                    ? PROJECT_MONITORED_DASHBOARD_CHART_HELPER(
                        pmgMonitoredProject.data
                      )
                    : PROJECT_MONITORED_CHART_HELPER(pmgMonitoredProject.data)
                }
                displayOnDashboard={displayOnDashboard}
                displayTitle="PMG Monitored Projects"
                extraTopSpace={true}
                updateValue={updateValue}
              />
            </div>

            {/* Right Section */}
            <div className="odd">
              <ChartsComponent
                isLoading={pmgMonitoredIssues.isLoading}
                chartConfig={
                  displayOnDashboard
                    ? ISSUE_MONITORED_CHART_DASHBOARD_HELPER(
                        pmgMonitoredIssues.data
                      )
                    : ISSUE_MONITORED_CHART_HELPER(pmgMonitoredIssues.data)
                }
                displayOnDashboard={displayOnDashboard}
                displayTitle="PMG Monitored Issues"
                extraTopSpace={true}
                updateValue={updateValue}
              />
            </div>
          </div>
        </div>
      )}
      {/* PDF First Section End */}

      {/* Second section */}
      {displayOnDashboard ? null : (
        <div className={`charts-sections issue-with-pmg-section`}>
          <ChartsComponent
            isLoading={issuesWithPMG.isLoading}
            chartConfig={ISSUES_WITH_PMG_HELPER(issuesWithPMG.data)}
            displayOnDashboard={displayOnDashboard}
          />
        </div>
      )}

      {displayOnDashboard ? (
        <ChartsDetails
          isLoading={issuesWithPMG.isLoading}
          data={projectStage.data}
          isDesktopView={isDesktopView}
          checkedValue={checkedValue}
        />
      ) : (
        <div className={`charts-sections ${dashboardClass}`}>
          <div className="chart">
            <div className="even">
              <ChartsComponent
                isLoading={issuesWithPMG.isLoading}
                chartConfig={STATUS_BREAK_UP_HELPER(projectStage.data)}
                displayOnDashboard={displayOnDashboard}
              />
            </div>
            <div className="odd">
              <ChartsComponent
                isLoading={issuesWithPMG.isLoading}
                chartConfig={STATUS_BREAK_UP_COST_HELPER(projectStage.data)}
                displayOnDashboard={displayOnDashboard}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export { FirstPage };
